@import "../../../containers/styles.module.scss";

.nightWorkersQuestionnaire {
  &__form {
    width: 309px;
    margin: 0 auto;
  }
  &__address {
    text-overflow: ellipsis;
    overflow: hidden;
    overflow-y: auto;
    resize: none;
  }
  &__date {
    margin-left: -2rem !important;
  }
  &__declaration {
    background: #ffffff;
    border: 1px solid #f2f2f2;
    box-sizing: border-box;
    box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 2.5rem;
  }

  &__buttons {
    margin-top: 2rem;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    margin-right: -10rem;
    @media (max-width: $size-md) {
      margin-right: 0;
    }
  }
}
